/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import {ReactNode} from 'react';
import {createPortal} from 'react-dom';

/**
 * Renders the given content into `document.body` via a portal, falling
 * back to rendering it in place when no document is available.
 *
 * ```typescript
 *
 *  import {renderInPortal} from '@ion/dls/src/filters/renderInPortal';
 *
 *  return renderInPortal(<div>Overlay content</div>);
 *
 * ```
 *
 * @param   content the node to portal into `document.body`.
 * @returns the portaled node, or `content` unchanged when no document body
 *          is available.
 */
export const renderInPortal = (content: ReactNode): ReactNode => (
  globalThis.document?.body ? createPortal(content, globalThis.document.body) : content
);

export default renderInPortal;
